import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "p",
  class: "control has-icons-left"
}
const _hoisted_2 = { class: "icon is-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MonthPickerInput = _resolveComponent("MonthPickerInput")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    (_openBlock(), _createBlock(_component_MonthPickerInput, _mergeProps(this.$attrs, {
      lang: _ctx.lang,
      "default-month": this.pickerDefaultMonth,
      "default-year": this.pickerDefaultYear,
      "input-pre-filled": this.inputPreFilled,
      onInput: _ctx.onMonthPickerInput,
      key: _ctx.pickerRemountTrigger
    }), null, 16, ["lang", "default-month", "default-year", "input-pre-filled", "onInput"])),
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_component_svg_icon, {
        type: "mdi",
        path: _ctx.icon
      }, null, 8, ["path"])
    ])
  ]))
}